import { useState } from 'react';

const C = {
  navy:     '#0C1A36',
  navy2:    '#112240',
  teal:     '#00A8CC',
  gold:     '#F5C800',
  offwhite: '#EDF1FF',
  muted:    '#7A90B8',
  green:    '#3DAA4A',
  red:      '#C0223A',
};

export default function ForgotPassword() {
  const [email,     setEmail]     = useState('');
  const [loading,   setLoading]   = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error,     setError]     = useState('');
  const [focused,   setFocused]   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await fetch('/api/users/forgot-password', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ email }),
      });
      setSubmitted(true);
    } catch {
      setError('Network error — please check your connection and try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight:       '100vh',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      backgroundColor: C.navy,
      fontFamily:      'Sora, sans-serif',
      padding:         '16px',
    }}>
      <div style={{
        backgroundColor: C.navy2,
        borderRadius:    '12px',
        padding:         '48px',
        width:           '100%',
        maxWidth:        '420px',
        boxShadow:       '0 20px 60px rgba(0,0,0,0.4)',
      }}>

        {/* Wordmark */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '1.8rem', fontWeight: 800, letterSpacing: '-0.5px' }}>
            <span style={{ color: '#1A7FBE' }}>Acct</span>
            <span style={{ color: C.gold  }}>4</span>
            <span style={{ color: C.green }}>Cast</span>
          </div>
          <p style={{ color: C.muted, fontSize: '0.875rem', marginTop: '8px', marginBottom: 0 }}>
            CFO-level financial intelligence
          </p>
        </div>

        {submitted ? (
          /* ── Success state ── */
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width:          '56px',
              height:         '56px',
              borderRadius:   '50%',
              background:     C.green + '22',
              border:         `2px solid ${C.green}`,
              display:        'flex',
              alignItems:     'center',
              justifyContent: 'center',
              margin:         '0 auto 20px',
              fontSize:       '1.6rem',
            }}>
              ✓
            </div>
            <h2 style={{ color: C.offwhite, fontSize: '1.25rem', fontWeight: 700, margin: '0 0 12px' }}>
              Check your email
            </h2>
            <p style={{ color: C.muted, fontSize: '0.875rem', lineHeight: 1.6, margin: '0 0 28px' }}>
              If an account exists for that email, a reset link has been sent.
              Check your spam folder if you don't see it.
            </p>
            <a
              href="/login"
              style={{ color: C.teal, fontSize: '0.9rem', textDecoration: 'none', fontWeight: 600 }}
            >
              ← Back to Login
            </a>
          </div>
        ) : (
          /* ── Form state ── */
          <>
            <h2 style={{ color: C.offwhite, fontSize: '1.25rem', fontWeight: 700, margin: '0 0 8px', textAlign: 'center' }}>
              Reset Password
            </h2>
            <p style={{ color: C.muted, fontSize: '0.875rem', textAlign: 'center', margin: '0 0 28px', lineHeight: 1.5 }}>
              Enter your email and we'll send a reset link.
            </p>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display:      'block',
                  color:        C.offwhite,
                  fontSize:     '0.875rem',
                  marginBottom: '8px',
                  fontWeight:   600,
                }}>
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onFocus={() => setFocused(true)}
                  onBlur={() => setFocused(false)}
                  required
                  placeholder="you@company.com"
                  style={{
                    width:           '100%',
                    padding:         '12px 16px',
                    backgroundColor: C.navy,
                    border:          `1px solid ${focused ? C.teal : '#2A3F5F'}`,
                    borderRadius:    '8px',
                    color:           C.offwhite,
                    fontSize:        '1rem',
                    fontFamily:      'Sora, sans-serif',
                    boxSizing:       'border-box',
                    outline:         'none',
                    transition:      'border-color 0.15s',
                  }}
                />
              </div>

              {error && (
                <div style={{
                  background:    C.red + '18',
                  border:        `1px solid ${C.red}`,
                  borderRadius:  '8px',
                  color:         C.red,
                  fontSize:      '0.875rem',
                  padding:       '10px 14px',
                  marginBottom:  '16px',
                }}>
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                style={{
                  width:         '100%',
                  padding:       '14px',
                  background:    `linear-gradient(135deg, ${C.teal}, ${C.green})`,
                  border:        'none',
                  borderRadius:  '8px',
                  color:         '#fff',
                  fontSize:      '1rem',
                  fontFamily:    'Sora, sans-serif',
                  fontWeight:    700,
                  cursor:        loading ? 'not-allowed' : 'pointer',
                  opacity:       loading ? 0.7 : 1,
                  letterSpacing: '0.3px',
                  marginBottom:  '20px',
                }}
              >
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>

            <div style={{ textAlign: 'center' }}>
              <a
                href="/login"
                style={{ color: C.muted, fontSize: '0.875rem', textDecoration: 'none' }}
                onMouseOver={e => e.target.style.color = C.teal}
                onMouseOut={e  => e.target.style.color = C.muted}
              >
                ← Back to Login
              </a>
            </div>
          </>
        )}

      </div>
    </div>
  );
}
